import styled from "styled-components";

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  padding: 120px 0 30px;
  @media (min-width: 768px) {
    padding: 150px 0 0;
  }
`;
export const ButtonsNavContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
export const ButtonNewContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0 30px;
`;
export const IntraContainer = styled.section`
  height: 70%;
`;
export const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  overflow: auto;
  ::-webkit-scrollbar {
    width: 0.5rem;
  }
  ::-webkit-scrollbar-track {
    background: #ececec;
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: var(--secondary-color);
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }
`;
export const Item = styled.li``;
